import React from "react";

/*
 * Fields fill the column they are placed in rather than carrying a fixed
 * width, so the grid decides the layout and the modal's width stays the one
 * thing that sets how wide anything is.
 */
export const Field = `flex w-full flex-col gap-1`;
export const FieldLabel = `text-xs font-medium uppercase tracking-wide text-neutral-500`;
/** The one submit-button style the three forms share. */
export const SubmitButton = `rounded-md bg-neutral-800 px-6 py-2.5 text-sm font-medium tracking-wide text-white transition-colors hover:bg-neutral-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60`;
export const FieldInput = `w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-800 transition-colors placeholder:text-neutral-400 focus:border-neutral-500 focus:outline-none focus:ring-1 focus:ring-neutral-400`;

export default function Input(props: {
  name: string;
  label: string;
  value: string;
  handleChange: (e: React.FormEvent<HTMLInputElement>) => void;
  fref: React.RefObject<HTMLInputElement>;
  labelClasses?: string;
  inputClasses?: string;
  placeholder?: string;
}) {
  return (
    <div className={Field}>
      <div
        className={`${FieldLabel} ${props.labelClasses} focus:text-bold focus:text-black`}
      >
        {props.label}
      </div>
      <input
        className={`${FieldInput} ${props.inputClasses}`}
        name={props.name}
        value={props.value}
        onChange={props.handleChange}
        ref={props.fref}
        placeholder={props.placeholder ? props.placeholder : ''}
      />
    </div>
  );
}
